<template>
  <div class="auth-content back-auth-content">
    <div class="auth-title">
      <strong>{{ "추가인증" }}</strong> {{ "실명확인 입출금 계좌 인증" }}
    </div>
    <div class="sub-title">
      {{ "- 원화 입금 및 출금 가능(외국인 불가)" }}<br />
      {{ "- 실명확인 입출금 계좌 등록 및 발급" }}
    </div>

    <!-- 가상계좌 발급 전. 신원인증 후 -->
    <div
      v-if="
        (isAuthStatus == 'E' || isAuthStatus == 'RE') &&
          accounts.vrAccount == null
      "
      @click="nextBankDetail"
      class="auth-line"
      flex
      fic
      fjs
    >
      <div class="data full" flex fjb>
        <div flex fjb>
          <div class="icon-bank"></div>
          <div class="value">
            {{ "실명확인 입출금 계좌 발급" }}
          </div>
        </div>
        <img
          src="../../../../../src/assets/img/mypage/button_arrow_right_icon.svg"
          alt=""
        />
      </div>
    </div>
    <!-- //가상계좌 발급 전 -->

    <!-- 가상계좌 발급 완료 -->
    <div
      v-else-if="accounts.vrAccount !== null"
      class="auth-line"
      :class="{ auth: accounts.vrAccount !== null }"
      flex
      fjb
    >
      <div class="data" flex>
        <div class="icon-bank"></div>
        <div class="ml29">
          {{ "부산은행 계좌번호" }}
          <br> 
          <span v-if="Server.version < 10">{{ accountMasking(accounts.deposit.accountNumber) }}</span>
          <span v-else>{{ accounts.deposit.accountNumber }}</span>
          <br>
          {{ "실명확인 입출금 계좌번호" }}<br>
          <span v-if="Server.version < 10">{{ accountMasking(accounts.vrAccount.accountNumber) }}</span>
          <span v-else>{{ accounts.vrAccount.accountNumber }}</span>
        </div>
      </div>
      <div class="status">
        {{ $t("mypage.verify.verificationComplete") }}
        <img
          src="../../../../../src/assets/img/mypage/check_ic.svg"
          class="ml4"
          alt=""
        />
      </div>
    </div>
    <!-- //가상계좌 발급 완료 -->

    <!-- 가상계좌 발급 전. 신원인증 전 -->
    <div class="auth-line" v-else @click="openNotiAlert">
      <div class="data full" flex fjb>
        <div flex fjb>
          <div class="icon-bank"></div>
          <div class="value">
            {{ "실명확인 입출금 계좌 발급" }}
          </div>
        </div>
        <img
          src="../../../../../src/assets/img/mypage/button_arrow_right_icon.svg"
          alt=""
        />
      </div>
    </div>
    <!-- //가상계좌 발급 전. 신원인증 전 -->
  </div>
</template>

<script>
import Api from "@/common/Api";
import Moment from "moment";
import { mapState, mapGetters } from "vuex";
import Masking from "@/common/masking.js";

export default {
  props: ["authData", "phone"],
  components: {
    // AuthAccount
  },
  data() {
    return {
      accountAuthCompleteModal: false,
      bankList: null,
      accountForm: {
        bankMCode: "",
        accountNo: "",
        smsAuthCode: "",
        smsAuthToken: 0,
        smsAuthTimer: null,
        smsAuthExpire: 0,
        smsAuthRemain: "00:00",
        privacyCheck: false,
      },
    };
  },
  created() {
    Api.Setting.getBankList().then((response) => {
      const bankList = _.filter(response.body, (bank) => bank.mcode);
      this.bankList = bankList;
    });
  },
  computed: {
    ...mapGetters([
      "userInfo",
      "authLevel",
      "authStep",
      "accounts",
      "authResidence",
      "useOTP",
      "hasAccount",
      "accounts",
    ]),
    isAuthStatus() {
      const status = this.userInfo.dueDiligenceInfo.sbStatus;
      if (!status) {
        return status == "N";
      } else {
        return status;
      }
    },
    ...mapState(["Server"])
  },
  methods: {
    // 실시간 계좌 발급
    nextBankDetail() {
      this.$router.push({
        name: "authAccount",
        query: {
          phone: this.phone,
        },
      });
    },
    // 실시간 계좌 발급
    showAccount(show) {
      if (this.authLevel < 2) {
        this.notiNotAllowed("본인인증");
        return false;
      }
      this.accountAuthModal = show;
    },
    requestPhoneAuth() {
      Api.requestMeansToken("SMS").then((response) => {
        this.accountForm.smsAuthToken = response.body.token;
        this.accountForm.smsAuthExpire = Moment().add(3, "minutes");
        this.accountForm.smsAuthRemain = "03:00";
        this.accountForm.smsAuthTimer = setInterval(
          this.smsRemainTime.bind(this),
          300
        );
      });
    },
    smsRemainTime() {
      if (this.accountForm.smsAuthTimer) {
        const remain = Moment.duration(
          this.accountForm.smsAuthExpire - Moment()
        );
        if (remain < 0) {
          this.deactivateSmsTimer();
          this.accountForm.smsAuthRemain = 0;
        }

        this.accountForm.smsAuthRemain = Moment(+remain).format("mm:ss");
      } else {
        this.accountForm.smsAuthRemain = 0;
      }
    },
    deactivateSmsTimer() {
      clearInterval(this.accountForm.smsAuthTimer);
      this.accountForm.smsAuthTimer = -1;
      this.accountForm.smsAuthExpire = 0;
    },
    requestAccountCheck() {
      if (!this.accountForm.privacyCheck) {
        this.$vs.notify({
          title: "정보 제공 동의 필요",
          text: "개인정보 제공 동의에 체크해주세요.",
          color: "danger",
          position: "top-left",
        });
        return false;
      }
      if (this.accountForm.smsAuthTimer <= 0) {
        this.$vs.notify({
          title: "휴대폰 인증 필요",
          text: "휴대폰 인증을 진행해주세요.",
          color: "danger",
          position: "top-left",
        });
        return false;
      }

      return Api.registAccount({
        bankMCode: this.accountForm.bankMCode,
        accountNumber: this.accountForm.accountNo.replace(/-/g, ""),
        token: this.accountForm.smsAuthToken,
        code: this.accountForm.smsAuthCode,
        means: "SMS",
      })
        .then((response) => {
          this.$msgbox({
            title: "",
            message: "계좌 인증이 완료되었습니다.",
            customClass: "auth-success",
            confirmButtonText: this.$t("confirm.ok"),
            showCancelButton: false,
            dangerouslyUseHTMLString: true,
          });
          this.$store.dispatch("updateUserInfo");
          this.accountAuthModal = false;
          this.accountAuthCompleteModal = true;
          return true;
        })
        .catch((err) => {
          if (!err.msg) {
            // TODO:: 기본 메세지 override 필요
          }

          this.$vs.notify({
            title: "오류",
            text: err.msg,
            color: "danger",
            position: "top-left",
          });
        });
    },
    removeDash() {
      this.accountForm.accountNo = this.accountForm.accountNo.replace(/-/g, "");
    },
    close() {
      this.$emit("closeAccountModal");
    },
    // 계좌번호 마스킹 : 7자리부터 적용
    accountMasking(_value) {
      return Masking.accountMasking(_value);
    },
    openNotiAlert() {
      this.$vs.notify({
        text: "LEVEL 1 신원인증 완료 후 인증 가능합니다.",
        position: "top-left",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.back-auth-content {
  .keycolor {
    color: #eb3246;
  }
  div,
  input {
    box-sizing: border-box;
  }
  .auth-line {
    &.active {
      background: #f7f7f7;
    }
    ul {
      list-style: none;
      li {
        font-size: 11px;
      }
    }
    .content {
      &.title {
        font-size: 13px;
        font-weight: 500;
      }
      &.default {
        font-size: 13px;
      }
      .gray {
        color: #b4b4b4;
      }
    }
    .el-select {
      width: 100%;
      .el-input__inner {
        font-size: 13px;
        padding: 11px;
        height: 42px;
        line-height: 42px;
      }
    }
    .el-input__inner {
      font-size: 13px;
      padding: 11px;
      height: 42px;
      line-height: 42px;
    }

    .auth-info {
      font-size: 12px;
      color: #b4b4b4;
    }

    .warn-box {
      font-size: 11px;
      line-height: 1.55;
    }

    .el-checkbox {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      item-align: start;
      .el-checkbox__inner {
        margin-top: 4px;
        width: 22px;
        height: 22px;
        border-color: #707070;
        border-radius: 0px;
        &:after {
          font-size: 20px;
          height: 14px;
          left: 8px;
        }
      }
      .el-checkbox__label {
        font-size: 11px;
        white-space: pre-wrap;
      }
      &.is-checked {
        .el-checkbox__inner {
          background-color: #e10519;
        }
        .el-checkbox__label {
          color: #373237;
        }
      }
    }

    button {
      width: 100%;
      font-size: 14px;
      font-weight: bold;
      padding: 11px;
      &.cancel {
        width: 85px;
        border: 1px solid #e6e6e6;
        background-color: #fff;
        color: #b4b4b4;
      }
      &.submit {
        margin-left: 10px;
        width: calc(100% - 96px);
      }
      &.submit-account {
        width: 160px;
        height: 48px;
        font-size: 12px;
        font-weight: normal;
        background-color: #eb3246;
      }
    }
  }
}
</style>
